import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, icons, numberToPxOrString, sizes } from '@/utils'

import button from '@/components/button'
import squircle from '@/components/icon/squircle'
import draggable from '@/components/misc/draggable'

const baseClass = 'generator-row'
const handleClass = 'drag_handle'

function renderDragHandle(h) {
  if (this.canSortable) {
    return h(
      squircle,
      {
        class: handleClass,
        props: {
          icon: icons.drag_handle,
          color: Colors.grey,
          size: sizes.medium
        }
      }
    )
  }
}
function renderRowSlot(h, item, index) {
  if (this.$scopedSlots.row) {
    return this.$scopedSlots.row({
      item,
      index
    })
  }

  return this.$slots.row
}
function renderRemoveButton(h, index) {
  if (!this.readonly) {
    return h(
      button,
      {
        props: {
          icon: icons.remove,
          color: Colors.error,
          mode: buttonModes.flat,
          disabled: this.disabled
        },
        on: {
          click: () => {
            this.removeField(index)
          }
        }
      }
    )
  }
}
function renderItem(h, item, index) {
  return h(
    'div',
    {
      class: {
        [`${baseClass}-item`]: true,
        [`${baseClass}-item--sortable`]: this.sortable,
        [`${baseClass}-item--readonly`]: this.readonly
      }
    },
    [
      renderDragHandle.call(this, h),
      renderRowSlot.call(this, h, item, index),
      renderRemoveButton.call(this, h, index)
    ]
  )
}
function renderBody(h) {
  const callback = (item, index) => {
    return renderItem.call(this, h, item, index)
  }
  if (this.canSortable) {
    return h(
      draggable,
      {
        class: `${baseClass}-body`,
        style: { gap: numberToPxOrString(this.gap) },
        props: {
          value: this.proxy,
          disabled: this.disabled,
          handle: handleClass
        },
        on: {
          input: event => {
            this.proxy = event
          }
        },
        scopedSlots: { item: callback }
      }
    )
  } else {
    return h(
      'div',
      {
        class: `${baseClass}-body`,
        style: { gap: numberToPxOrString(this.gap) }
      },
      [
        this.proxy.map((item, index) => {
          return renderItem.call(this, h, item, index)
        })
      ]
    )
  }
}

function renderFooterSlot(h) {
  if (this.$scopedSlots.footer) {
    return this.$scopedSlots.footer()
  }

  return this.$slots.footer || h('div')
}
function renderAddButton(h) {
  if (!this.readonly) {
    return h(
      button,
      {
        props: {
          icon: icons.add,
          color: Colors.primary,
          mode: buttonModes.flat,
          disabled: this.canAdd
        },
        on: {
          click: () => {
            this.addField()
          }
        }
      }
    )
  }
}
function renderSortButton(h) {
  if (this.canSortBy) {
    return h(
      button,
      {
        props: {
          icon: icons.sort_by_alpha,
          color: Colors.primary,
          mode: buttonModes.flat,
          disabled: this.disabled
        },
        on: {
          click: () => {
            this.sort(this.proxy)
          }
        }
      }
    )
  }
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: {
        [`${baseClass}-footer`]: true,
        [`${baseClass}-footer--sort-by`]: !!this.sortBy
      }
    },
    [
      renderFooterSlot.call(this, h),
      renderSortButton.call(this, h),
      renderAddButton.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: baseClass
    },
    [
      renderBody.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
